// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../../common/JQueryView';

export default class NewView extends JQueryView {
  constructor() {
    super('.company.stockholder_meetings.resolution_reports.stockholders.new');
    this.renderAllCheckbox();
  }

  @on({ event: 'change', selector: 'input[name="all_checked"]' })
  onChangeAllCheck() {
    const allChecked = $('input[name="all_checked"]').prop('checked');
    if (allChecked) {
      $('input[type=checkbox]').prop('checked', true);
    } else {
      $('input[type=checkbox]').prop('checked', false);
    }
  }

  @on({ event: 'change', selector: $('input[type=checkbox]') })
  onChangeAllCheckbox() {
    this.renderAllCheckbox();
  }

  renderAllCheckbox() {
    const selectedCount = $(
      'input:checkbox:checked[id^="officer_approval_stockholder_meeting_officer_approval_stakeholders_attributes_"]',
    ).length;
    const totalCount = $(
      'input:checkbox[id^="officer_approval_stockholder_meeting_officer_approval_stakeholders_attributes_"]',
    ).length;

    if (totalCount === selectedCount) {
      $('input[name="all_checked"]').prop('checked', true);
    } else {
      $('input[name="all_checked"]').prop('checked', false);
    }
  }
}
